import { render, staticRenderFns } from "./forPc.vue?vue&type=template&id=490730e2"
import script from "./forPc.vue?vue&type=script&lang=js"
export * from "./forPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports